import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/accessibility/fr/accessibility_FR.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Accessibility/accessibility__de-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['de-DE'].layout },
  seo: {
    title: 'Erklärung bezüglich der Barrierefreiheit | Assurance Lemonade',
    metaTitle: 'Erklärung bezüglich der Barrierefreiheit | Assurance Lemonade',
    description:
      'Lemonade legt Wert darauf, die Inhalte seiner Website für alle zugänglich und leicht zugänglich zu gestalten. Wir nehmen Ihre Anregungen ernst, um die Zufriedenheit aller unserer Kunden sicherzustellen.',
    ogImage: og.src,
  },
  MDXContent: content as DocumentTypes,
};
